<template>
    <v-content class="px-0 mx-0">
      <v-container fluid class="primary">
      <v-row>
        <v-col>
          <v-container style="max-width: 1200px;">
          <h1 class="mt211-header secondary--text">Program Form</h1>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container style="max-width: 1200px;">
        <v-banner
            dark
            class="my-4"
            :single-line="false"
            style="background-color:#202450 !important;"
            :elevation="1"
          >
            Enter Progam below. If you haven't yet submitted your Agency you must do so before submitting Programs, please click the  "Agency" button.
            <template v-slot:actions>
              <v-btn
                to="agency"
                text
                color="white accent-4"
              >
                Agency
              </v-btn>
            </template>
          </v-banner>
          <v-banner
            v-if="update"
            dark
            class="my-4"
            :single-line="false"
            style="background-color:#202450 !important;"
            :elevation="1">
            Please complete only fields that have changed.  
          </v-banner>
     </v-container>
    <form-builder form-data="programData" />
  </v-content>
</template>

<script>
import FormBuilder from '../components/FormBuilder.vue';

export default {
  components: {
    FormBuilder,
  },
  computed: {
    update: {
       get() {
          return this.$store.state['update'];
        },
        set(value) {
          this.$store.commit("set_update", value);
        }
     },
  },
};
</script>
